{
  "collapse": "Samenvouwen",
  "expand": "Uitvouwen"
}
